import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import QPiatoLoading from "@/components/business/common/qpiato-loading";

const env = import.meta.env;

type LegacyPaymentCallbackRedirectProps = {
  status: "success" | "failure";
};

export const LegacyPaymentCallbackRedirect = ({
  status,
}: LegacyPaymentCallbackRedirectProps) => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const apiBase = (env.VITE_REACT_APP_API as string).endsWith("/")
      ? (env.VITE_REACT_APP_API as string).slice(0, -1)
      : (env.VITE_REACT_APP_API as string);

    const url = new URL(
      `${apiBase}/payments/transactions/callback/${status}`
    );
    searchParams.forEach((value, key) => {
      url.searchParams.set(key, value);
    });

    window.location.replace(url.toString());
  }, [status, searchParams]);

  return <QPiatoLoading />;
};
